import type { AppointmentTemplateTimeData } from '@/types/settings-api';

/**
 * Format an `AppointmentTemplateTimeData` (hour-int + minute-int +
 * AM/PM marker) as a display string like `"9:00 AM"` or `"10:30 PM"`.
 *
 * Wire shape verified PROD-762 PR-G cURL 2026-05-15:
 *   { hour: 9, minute: 0, format: "AM" } → "9:00 AM"
 *   { hour: 10, minute: 30, format: "PM" } → "10:30 PM"
 *
 * Returns `""` for null/undefined input so callers can fall back to
 * a placeholder. Hour is rendered unpadded (per Flutter convention
 * for appointment templates display); minute is always zero-padded
 * to 2 digits.
 *
 * NOTE: distinct from the other two time-of-day formats on the same
 * Schedule tab (`DoctorWorkingHourSlot` uses split STRINGS like
 * `"02 AM"` / `"00 min"`; `DoctorWorkingHoursListSlot` uses combined
 * STRINGS like `"08:00 AM"`). Don't confuse them.
 */
export function formatTemplateTime(
  time: AppointmentTemplateTimeData | null | undefined,
): string {
  if (!time) return '';
  const hour = time.hour;
  const minute = String(time.minute).padStart(2, '0');
  return `${hour}:${minute} ${time.format}`;
}
